import { modalAnatomy as parts } from "@chakra-ui/anatomy"
import { createMultiStyleConfigHelpers } from "@chakra-ui/styled-system"

// eslint-disable-next-line @typescript-eslint/unbound-method
const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(parts.keys)

const baseStyle = definePartsStyle({
  // define the part you're going to style
  overlay: {
    bg: "blackAlpha.800"
  },
  dialog: {
    borderRadius: "md",
    padding: 0
  },
  dialogContainer: {
    padding: 0
  }
})

export const modalTheme = defineMultiStyleConfig({
  baseStyle
})
